<template> 

  <div style="background-color: #d9e6f2; display: flex; flex-direction: row; justify-content: space-between; height: 70px; "> 
    <div>
      <a href="./">
        <img src="s/img/misc/PDBcov.svg" style="margin-right:5px; width: auto; height:60px">
      </a>
      <div style="display:inline-block;"> 
        <div style="text-align:center; font-size: 1.3em; font-weight: bold; color: blue;"> 2189 </div>
        <div style="font-size: 1.3em">records</div> 
      </div> 
    </div>
 
    <form action="search_bar" method="POST" style="display: flex; flex-direction: row;">
      <textarea name="foo" cols="40" rows="3" placeholder="PDB ID, DrugBank ID, Residue Name, Approved Drug" style="margin-top: 10px; margin-bottom: 10px"></textarea> 
      <input type="submit" value="Search" style="height:50px; margin: 10px;"> 
    </form> 
  </div> 

</template> 

<script>
export default {
  name: 'myHeader',  
} 

</script> 
 
<style scoped>    
</style>
 